// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2YdvP","content":"GlobalSearch_content__1Y1c2"};